import { render, staticRenderFns } from "./skeletonScreen.vue?vue&type=template&id=3525f01c&scoped=true&"
import script from "./skeletonScreen.vue?vue&type=script&lang=js&"
export * from "./skeletonScreen.vue?vue&type=script&lang=js&"
import style0 from "./skeletonScreen.vue?vue&type=style&index=0&id=3525f01c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3525f01c",
  null
  
)

export default component.exports